export enum PaymentMethodType {
    Card = 'card',
    Banks = 'banks',
}
